import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './i18n'
import App from './App'
import { RootStoreModel, RootStoreProvider } from 'models/root-store'

import { setupDataDog } from 'services/datadog'

setupDataDog()

const stores = RootStoreModel.create({})

ReactDOM.render(
  <React.StrictMode>
    <RootStoreProvider value={stores}>
      <App />
    </RootStoreProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)
